import { render, staticRenderFns } from "./singleStatisticalCard.vue?vue&type=template&id=56e67c3c&scoped=true&"
import script from "./singleStatisticalCard.vue?vue&type=script&lang=js&"
export * from "./singleStatisticalCard.vue?vue&type=script&lang=js&"
import style0 from "./singleStatisticalCard.vue?vue&type=style&index=0&id=56e67c3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e67c3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56e67c3c')) {
      api.createRecord('56e67c3c', component.options)
    } else {
      api.reload('56e67c3c', component.options)
    }
    module.hot.accept("./singleStatisticalCard.vue?vue&type=template&id=56e67c3c&scoped=true&", function () {
      api.rerender('56e67c3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/newDashboard/components/card/singleStatisticalCard.vue"
export default component.exports